import clsx from 'clsx'
import { v4 as uuidv4 } from 'uuid'
import styles from './Toggle.module.scss'

export const Toggle = ({ label, onChange, checked = false, className }: any) => {
  const uniqueId = uuidv4()

  return (
    <div className={clsx(styles.container, className)}>
      <label htmlFor={uniqueId} className={styles.label}>
        {label}
      </label>
      <input id={uniqueId} type='checkbox' className={styles.input} onChange={onChange} checked={checked} />
      <label htmlFor={uniqueId} className={styles.slider}>
        <span className={styles.visuallyHidden}></span>
      </label>
    </div>
  )
}
